import NextImage from 'components/NextImage/NextImage'
import { Image } from 'frontend/types'
import React from 'react'
import styles from './TakeOverContainer.module.css'

interface Props {
  children: React.ReactNode
  image: Image
  useImage?: boolean
}

const TakeOverContainer = ({ children, image, useImage = true }: Props) => {
  return (
    <div className={styles.backDrop}>
      <div className={styles.message}>{children}</div>
      {useImage && (
        <NextImage height={540} width={960} src={image['960x540']} />
      )}
    </div>
  )
}

export default TakeOverContainer
